import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  airlinesName: {},
  isLoading: false,
  error: "",
  hasData: false
};
const airlinesListSlice = createSlice({
  name: "airlinesList",
  initialState,
  reducers: {
    airlinesListRequest: state => {
      state.isLoading = true;
    },
    airlinesListRequestSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.airlinesName = action.payload;
    },
    airlinesListRequestFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.hasData = true;
    }
  }
});
export const {
  airlinesListRequest,
  airlinesListRequestSuccess,
  airlinesListRequestFailure
} = airlinesListSlice.actions;
export default airlinesListSlice.reducer;